import { useState, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Item } from './ItemModel';
import { CartViewModel } from '../../cart/CartViewModel';
import { createLogger } from '../../../util/logger';
import { useInventory } from '../../../contexts/InventoryContext';
import { generateSlug } from '../shopData';

const logger = createLogger('ItemViewModel');

export const useItemDetailViewModel = (itemProp?: Item, cart?: CartViewModel) => {
    const { slug } = useParams<{ slug: string }>();
    const navigate = useNavigate();
    const { items, isLoading } = useInventory();

    // Look up item by slug using inventory context items
    const routedItem = useMemo(() => {
        if (!slug) return undefined;
        return items.find(item => generateSlug(item.name) === slug);
    }, [slug, items]);

    const item = itemProp || routedItem;

    const [isDetailsDropdownOpen, setIsDetailsDropdownOpen] = useState(false);
    const [isBrewingMethodDropdownOpen, setIsBrewingMethodDropdownOpen] = useState(false);

    const handleBack = () => {
        navigate('/shop');
    };

    const toggleDetailsDropdown = () => {
        setIsDetailsDropdownOpen(!isDetailsDropdownOpen);
    };

    const toggleBrewingMethodDropdown = () => {
        setIsBrewingMethodDropdownOpen(!isBrewingMethodDropdownOpen);
    };

    const defaultCalculatePrice = (): string => {
        return item ? item.price.toFixed(2) : '0.00';
    };

    const defaultHandleAddToCart = (): void => {
        if (item && cart) {
            const result = cart.addItem(item);
            logger.log('Add to cart result:', result);
        }
    };

    return {
        item,
        isLoading,
        handleBack,
        isDetailsDropdownOpen,
        isBrewingMethodDropdownOpen,
        toggleDetailsDropdown,
        toggleBrewingMethodDropdown,
        defaultCalculatePrice,
        defaultHandleAddToCart,
    };
};
